import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { ArrowDownList, ArrowDownListItem, } from '@/components/ui/List/ArrowDownList';
import { Card } from '@/components/ui/Surface/Card';
import { DirectionsWalkIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
const flows = [
    { step: '01', text: '詳細閲覧' },
    { step: '02', text: '質疑応答（オンライン）' },
    { step: '03', text: '提案意向の登録' },
    { step: '04', text: '提案提出' },
    { step: '05', text: '面談実施' },
    { step: '06', text: '受注・PJ開始' },
];
/**
 * 案件提案のフローを示すためのコンポーネント
 * @description 閲覧申請未承認の時に表示する
 * @param props
 * @constructor
 */
export const RfpProfessionalOneUnapprovedFlowCard = (props) => {
    const { className = '' } = props;
    return (_jsxs(Card, Object.assign({ className: clsx('w-full', 'px-16 md:px-20 py-20', 'overflow-hidden', className), isRounded: true, isShadow: true }, { children: [_jsxs(IconTextGroup, Object.assign({ className: 'mb-20' }, { children: [_jsx(DirectionsWalkIcon, { className: 'flex', color: 'base', size: 'sm' }), _jsx(Text, Object.assign({ color: 'base', isBold: true, size: 'md' }, { children: "\u3054\u63D0\u6848\u306E\u9032\u3081\u65B9" }))] })), _jsx(ArrowDownList, Object.assign({ className: 'w-full' }, { children: flows.map((flow) => (_jsx(ArrowDownListItem, Object.assign({ className: 'last:pb-0' }, { children: _jsxs("div", Object.assign({ className: 'flex' }, { children: [_jsx(Text, Object.assign({ className: 'mr-16', color: 'textGray', fontFamily: 'alpha', size: 'sm' }, { children: `Step.${flow.step}` })), _jsx(Text, Object.assign({ color: 'base', isBold: true, size: 'sm' }, { children: flow.text }))] })) }), flow.text))) }))] })));
};
